import React from "react";
import { FiHeart } from "react-icons/fi";
import { baseurl } from "../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";

function Wishlist({ productId }) {
  const customerId = localStorage.getItem("customerId");

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });

  const handleAddToWishlist = async () => {
    if (!customerId) {
      Toast.fire({
        icon: "warning",
        title: "Please login first"
      });
      return;
    }

    const payload = {
      customerId: customerId,
      productId: productId,
    };

    // console.log("Wishlist Payload:", payload);

    try {
      // Note: Ensure your baseurl has a trailing slash or add it here
      const response = await axios.post(`${baseurl}/addToWishlist`, payload);
      
    //   console.log("Full Response:", response);

      // 1. Handle "Already Exists" case (Backend returns success: false and alreadyExists: true)
      if (response.data.alreadyExists) {
        Toast.fire({
          icon: "info",
          title: response.data.message || "Already in wishlist"
        });
      } 
      // 2. Handle "Success" case (New entry created)
      else if (response.data.success || response.status === 201) {
        Toast.fire({
          icon: "success",
          title: response.data.message || "Added to wishlist"
        });
      }
    } catch (error) {
      console.error("Error adding to wishlist:", error);
      Toast.fire({
        icon: "error",
        title: error.response?.data?.message || "Failed to add item"
      });
    }
  };

  return (
    <button 
      className="action-btn" 
      title="Add to Wishlist" 
      onClick={handleAddToWishlist}
    >
      <FiHeart />
    </button>
  );
}

export default Wishlist;